import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import logo from "../../assets/IconMetuaa.png";
import profileAvatar from "../../assets/images/avatar.png";
import "../../Pages/DashboardClient/HomePage.css";
import "./dashboardTheme.css";
import { hideLoader, showLoader } from "../../Redux/Loader/actions";
import { apiUrl } from "../../Constants";
import { LocaleSelector } from "../../components/shared";
import "../../components/style.css";

function getHeaderLinks () {
  return [
    { label: "covoiturage", href: "/" },
    { label: "bus", href: "/" },
    { label: "train", href: "/" },
    { label: "livraison", href: "/" },
    { label: "courses", href: "/" },
    { label: "offres", href: "/", badge: "nouveau"},
  ];
}

function getSidebarPrimary() {
  return [
    { label: "Tableau de bord",   icon: "grid",   href: "/dashboard-entreprise" },
    { label: "Véhicules",      icon: "car",    href: "/corporate-vehicles" },
    { label: "Conducteurs",       icon: "taxi",   href: "/corporate-drivers" },
    { label: "Voyages",         icon: "map",    href: "/corporate-rides" },
    { label: "Réservations",  icon: "map",    href: "/corporate-courses" },
    { label: "Rapports",       icon: "chart",  href: "/overallreport-corp" },
    { label: "Wallet",        icon: "wallet", href: "/wallet-entreprise" },
  ];
}

function getSidebarAccount() {
  return [
    { label: "Profile", icon: "user", href: "/profile-entreprise" },
    { label: "Paramètres", icon: "settings", href: "/settings-driver" },
  ];
}

function LogoMark() {
  return <img src={logo} alt="Logo METUA'A" className="dbc-logo-image" />;
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4a5 5 0 0 0-5 5v2.5c0 .9-.3 2.1-.8 3l-.9 1.5h13.4l-.9-1.5c-.5-.9-.8-2.1-.8-3V9a5 5 0 0 0-5-5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

function GridIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="4" width="6" height="6" rx="1.5" />
      <rect x="14" y="4" width="6" height="6" rx="1.5" />
      <rect x="4" y="14" width="6" height="6" rx="1.5" />
      <rect x="14" y="14" width="6" height="6" rx="1.5" />
    </svg>
  );
}

function RoutesIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6h4a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H8a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h10" />
      <path d="M15 18l3-3-3-3" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5v5l3 2" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function WalletIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5V17a2 2 0 0 1-2 2H6.5A2.5 2.5 0 0 1 4 16.5v-8Z" />
      <path d="M15.5 12.5h4" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" />
      <path d="M8.5 10V8.5a3.5 3.5 0 1 1 7 0V10" />
    </svg>
  );
}

function HeartIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 20s-7-4.5-7-9.5A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 7 3.5C19 15.5 12 20 12 20Z" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.2" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function SettingsIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10.8 4.8h2.4l.4 2a6.2 6.2 0 0 1 1.6.7l1.8-1 1.7 1.7-1 1.8c.3.5.5 1 .7 1.6l2 .4v2.4l-2 .4a6.2 6.2 0 0 1-.7 1.6l1 1.8-1.7 1.7-1.8-1a6.2 6.2 0 0 1-1.6.7l-.4 2h-2.4l-.4-2a6.2 6.2 0 0 1-1.6-.7l-1.8 1-1.7-1.7 1-1.8a6.2 6.2 0 0 1-.7-1.6l-2-.4v-2.4l2-.4c.1-.6.4-1.1.7-1.6l-1-1.8 1.7-1.7 1.8 1c.5-.3 1-.5 1.6-.7l.4-2Z" />
      <circle cx="12" cy="12" r="2.4" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="9" cy="7" r="3" />
      <path d="M3 21v-1.5A4.5 4.5 0 0 1 7.5 15h3A4.5 4.5 0 0 1 15 19.5V21" />
      <circle cx="17" cy="7" r="2.5" />
      <path d="M21 21v-1a3.5 3.5 0 0 0-3.5-3.5h-.5" />
    </svg>
  );
}

function PersonIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.2" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function CarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 17H3v-5l2.5-4.5h13L21 12v5h-2" />
      <circle cx="7.5" cy="17.5" r="1.5" />
      <circle cx="16.5" cy="17.5" r="1.5" />
      <path d="M5 12h14" />
    </svg>
  );
}

function TaxiIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 17H3a1 1 0 0 1-1-1v-5l2.5-5h13L20 11v5a1 1 0 0 1-1 1h-2" />
      <circle cx="7.5" cy="17.5" r="1.5" />
      <circle cx="16.5" cy="17.5" r="1.5" />
      <path d="M5 11h14" />
      <path d="M9 6.5 8 11M15 6.5 16 11" />
    </svg>
  );
}

function ChartIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="12" width="4" height="9" rx="1" />
      <rect x="10" y="7" width="4" height="14" rx="1" />
      <rect x="17" y="3" width="4" height="18" rx="1" />
    </svg>
  );
}

function SidebarButton({ item, activeLabel, locked = false, lockedTitle }) {
  const Icon =
    locked               ? LockIcon :
    item.icon === "grid"     ? GridIcon :
    item.icon === "routes"   ? RoutesIcon :
    item.icon === "clock"    ? ClockIcon :
    item.icon === "card"     ? CardIcon :
    item.icon === "wallet"   ? WalletIcon :
    item.icon === "heart"    ? HeartIcon :
    item.icon === "user"     ? UserIcon :
    item.icon === "settings" ? SettingsIcon :
    item.icon === "shield"   ? ShieldIcon :
    item.icon === "users"    ? UsersIcon :
    item.icon === "person"   ? PersonIcon :
    item.icon === "car"      ? CarIcon :
    item.icon === "taxi"     ? TaxiIcon :
    item.icon === "chart"    ? ChartIcon :
    BellIcon;

  return (
    <Link
      to={item.href}
      className={`dbc-sidebar-item ${item.label === activeLabel ? "is-active" : ""} ${locked ? "is-locked" : ""}`}
      aria-disabled={locked}
      tabIndex={locked ? -1 : undefined}
      title={locked ? lockedTitle : undefined}
      onClick={locked ? (event) => event.preventDefault() : undefined}
    >
      <span className={`dbc-sidebar-icon ${locked ? "is-locked" : ""}`}>
        <Icon />
      </span>
      <span>{item.label}</span>
    </Link>
  );
}

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const authUser = useSelector((state) => state?.AuthReducer?.user || {});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const headerLinks = getHeaderLinks();

  

  const resolvedUser = {
    firstName: authUser?.firstName || authUser?.first_name || "",
    lastName: authUser?.lastName || authUser?.last_name || "",
    email: authUser?.email || "",
    phone: authUser?.phone || "",
    avatar: authUser?.avatar_url || "",
    image_local: authUser?.image_local || "",
  };

  const displayName = authUser?.name || `${resolvedUser.firstName} ${resolvedUser.lastName}`.trim() || "Utilisateur";
  const displaySubtitle = resolvedUser.email || resolvedUser.phone || "Voir le profil";

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }

    const handleOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [menuOpen]);

  const handleLogout = () => {
    dispatch(showLoader("Loging out..."));
    localStorage.clear();
    navigate(0);
    dispatch(hideLoader());
  };

  return (
    <header className="dbc-nav-shell">
      <div className="dbc-container dbc-nav-container">
        <div className="dbc-nav">
          <Link to="/" className="dbc-logo" aria-label="METUA'A">
            <LogoMark />
            <span>METUA&apos;A</span>
          </Link>

          <nav className="dbc-main-links" aria-label="Navigation principale">
            {headerLinks.map((item) => (
              <a key={item.label} href={item.href} className="dbc-main-link">
                <span>{item.label}</span>
                {item.badge ? <span className="dbc-main-badge">{item.badge}</span> : null}
              </a>
            ))}
          </nav>

          <div className="dbc-right">
            <LocaleSelector />

            <button type="button" className="dbc-notification-btn" aria-label="Notifications">
              <BellIcon />
              <span className="dbc-notification-badge">3</span>
            </button>

            <button
              type="button"
              className="dbc-profile-btn"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((value) => !value)}
            >
              <span className="dbc-profile-avatar" aria-hidden="true">
                <img
                  src={resolvedUser.image_local !== "" ? apiUrl + resolvedUser.image_local : profileAvatar}
                  alt=""
                  aria-hidden="true"
                />
              </span>
              <span className="dbc-profile-copy">
                <strong>{displayName}</strong>
                <small>{displaySubtitle}</small>
              </span>
              <ChevronDownIcon />
            </button>

            {menuOpen ? (
              <div className="dbc-user-menu" ref={menuRef}>
                <Link to="/" className="dbc-user-menu-item" onClick={() => setMenuOpen(false)}>
                  Profile
                </Link>
                <Link to="/" className="dbc-user-menu-item" onClick={handleLogout}>
                  Déconnexion
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
}

function Sidebar({ activeSidebarLabel }) {
   const sidebarPrimary = getSidebarPrimary();
  const sidebarAccount = getSidebarAccount();

 
  return (
    <aside className="dbc-sidebar">
      <div className="dbc-sidebar-panel">
        <div className="dbc-sidebar-nav">
          {sidebarPrimary.map((item) => (
            <SidebarButton key={item.label} item={item} activeLabel={activeSidebarLabel} />
          ))}

          <div className="dbc-sidebar-section">
            <h4>Compte</h4>
            {sidebarAccount.map((item) => (
              <SidebarButton key={item.label} item={item} activeLabel={activeSidebarLabel} />
            ))}
          </div>
        </div>

        <div className="dbc-promo-card">
          <div className="dbc-promo-copy">
            <span className="dbc-promo-kicker">voyagez, économisez et gagnez des points</span>
            <p>Plus vous voyagez, plus vous cumulez des avantages</p>
          </div>

          <div className="dbc-promo-illustration" aria-hidden="true">
            <div className="dbc-promo-cloud dbc-promo-cloud-1" />
            <div className="dbc-promo-cloud dbc-promo-cloud-2" />
            <div className="dbc-promo-tree" />
            <div className="dbc-promo-car">
              <span />
              <span />
            </div>
          </div>

          <button type="button" className="dbc-promo-btn">
           Découvrir le programme
          </button>
        </div>
      </div>
    </aside>
  );
}

export default function DashboardEntrepriseLayout({
  children,
  activeSidebarLabel,
  sidebarTheme = "",
}) {
  const pageClassName = `dbc-page ${sidebarTheme ? `dbc-page--${sidebarTheme}` : ""}`.trim();

  return (
    <div className={pageClassName}>
      <Header />
      <main className="dbc-main">
        <div className="dbc-container dbc-layout">
          <Sidebar activeSidebarLabel={activeSidebarLabel} />
          <section className="dbc-content">{children}</section>
        </div>
      </main>
    </div>
  );
}
